import React from "react";
import styled from 'styled-components/macro'
import EnvimationIcon from "../../../../shared-components/EnvimationIcon/EnvimationIcon";
import PropTypes from "prop-types";

const SharingWrapper = styled.div``;

const StyledLink = styled.a`
    text-align: center;
    &:hover {
        cursor: pointer;
    };
    margin-right: 0.3em;
`;

class SocialLink extends React.Component {
    constructor(props) {
        super(props);
        this.popupShare = this.popupShare.bind(this);
    }

    popupShare() {
        window.open(this.props.url, '_blank', 'scrollbars,resizable,height=525,width=600');
        return false;
    };

    render() {
        return (
            <StyledLink onClick={this.popupShare} target="_blank">
                <EnvimationIcon
                    iconElement={this.props.icon}
                    color={this.props.color}
                    iconStyle="brand"
                    title={this.props.linkText}
                    size="2x"/>
            </StyledLink>
        )
    }
}

SocialLink.defaultProps = {};

SocialLink.propTypes = {
    icon: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
};

class SocialArea extends React.Component {
    constructor(props) {
        super(props);
        const currentUrl = window.location.href;
        const title = props.title;
        const tags = props.tags.join(",");
        const shortSummary = props.shortSummary;
        const socialMap = {
            "reddit":
                {
                    "name": "reddit",
                    "url": "https://reddit.com/submit?url=" + currentUrl +
                        "&title=" + title,
                    "icon": "reddit-square",
                    "color": "#FF4500"
                },
            "ycombinator":
                {
                    "name": "ycombinator",
                    "url": "https://news.ycombinator.com/submitlink?u=" + currentUrl + "&t=" + title,
                    "icon": "hacker-news-square",
                    "color": "#ff6500"
                },
            "twitter":
                {
                    "name": "twitter",
                    "url": "https://twitter.com/intent/tweet?text=" + shortSummary +
                        "&url=" + currentUrl +
                        "&hashtags=" + tags
                    ,
                    "icon": "twitter",
                    "color": "#00aced"
                }
        };
        this.state = {elements: socialMap}
    }

    render() {
        return (
            <SharingWrapper>
                {Object.values(this.state.elements).map((value, index) => {
                    return <SocialLink key={index}
                                       icon={value.icon}
                                       url={value.url}
                                       linkText={value.name}
                                       color={value.color}/>
                })}
            </SharingWrapper>
        );
    }
}


SocialArea.defaultProps = {
    title: "httpmate"
};

SocialArea.propTypes = {
    title: PropTypes.string.isRequired,
    tags: PropTypes.array,
    shortSummary: PropTypes.string.isRequired
};

export {SocialArea};
